import * as React from "react";
import { SurveyQuestion } from "../../../types";
import StoreContainer from "../../../stores/StoreContainer";

interface QuestionLabelProps {
  question: SurveyQuestion;
}

const QuestionLabel = ({ question }: QuestionLabelProps) => {
  const renderAsterisk = () => {
    if (!question.Required) {
      return null;
    }

    return <span aria-hidden="true">* </span>;
  };

  const language = StoreContainer.SettingStore.getConfig()?.Language || "en";
  return (
    <label
      lang={language}
      id={`velaro-survey-question-label-${question.QuestionID}`}
      htmlFor={`velaro-survey-question-${question.QuestionID}`}
    >
      {renderAsterisk()}
      <span dangerouslySetInnerHTML={{ __html: question.QuestionText }}></span>
    </label>
  );
};

export default QuestionLabel;
